import { BASE_URL } from '../../constants';
import { secureFetch } from '../../utils/secureFetch';

export const fetchAthletesByCondition = (condition) => async (dispatch, getState) => {
  try {
    const search = condition['search'] ? `&search=${encodeURIComponent(condition['search'])}` : '';
    const teamOnly = condition['team_only'] ? '&team_only=true' : '';
    // Staff-only: scope team_only to a specific coach (admin "Team Players").
    const coachEmail = condition['coachEmail'] ? `&coachEmail=${encodeURIComponent(condition['coachEmail'])}` : '';
    const data = await secureFetch({ method: 'GET', url: `${BASE_URL}/api/users/business/athletes/?sport=${condition['sport']}&searchFields=${condition['searchFields']}&page=${condition['page']}&limit=${condition['limit']}${search}${teamOnly}${coachEmail}`, getState });
    dispatch({ type: 'GET_ATHLETES_PROFILE', payload: data.athletes, totalCounts: data.total_counts });
  } catch (err) {
    console.error('fetchAthletesByCondition error:', err);
  }
};

export const fetchAthletesSportTabs = () => async (dispatch, getState) => {
  try {
    const data = await secureFetch({ method: 'GET', url: `${BASE_URL}/api/users/business/athletes/sporttabs/`, getState });
    dispatch({ type: 'GET_SPORT_TABS', payload: data });
  } catch ( err ) { 
    console.error('fetchAthletesSportTabs error:', err);
  }
};

export const fetchCacheInformation = (email) => async (dispatch, getState) => {
  try {
    const data = await secureFetch({ method: 'GET', url: `${BASE_URL}/api/users/business/athletes/about/${encodeURIComponent(email)}/`, getState });
    dispatch({ type: 'GET_CACHE_INFORMATION', payload: data });
  } catch ( err ) { 
    console.error('fetchCacheInformation error:', err);
  }
};

export const fetchCacheInformationById = (athleteId) => async (dispatch, getState) => {
  try {
    const data = await secureFetch({ method: 'GET', url: `${BASE_URL}/api/users/business/athletes/about/id/${athleteId}/`, getState });
    dispatch({ type: 'GET_CACHE_INFORMATION', payload: data });
    return data;
  } catch (err) {
    console.error('fetchCacheInformationById error:', err);
    return null;
  }
};

export const clearAthletes = () => ({
  type: 'CLEAR_ATHLETES',
});

export const clearBusinessAthlete = () => ({
  type: 'CLEAR_BUSINESS_ATHLETE',
});

export const clearBusinessCacheInformation = () => ({
  type: 'CLEAR_BUSINESS_CACHE_INFORMATION',
});
